import { render, staticRenderFns } from "./WarrantyItemHistory.vue?vue&type=template&id=4fbc7cca"
import script from "./WarrantyItemHistory.vue?vue&type=script&lang=js"
export * from "./WarrantyItemHistory.vue?vue&type=script&lang=js"
import style0 from "./WarrantyItemHistory.vue?vue&type=style&index=0&id=4fbc7cca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports